import styled from 'styled-components';
import { Section as BannerSection } from './banner-section';
import { Section } from './section';

const FeatureDiscoveryComponent = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: var(--spacing-06);

  ${Section},
  ${BannerSection} {
    width: 878px;
    max-width: 80%;
    margin: var(--spacing-06) auto var(--spacing-07);
  }
`;

type FeatureDiscovery = typeof FeatureDiscoveryComponent & {
  Section: typeof Section;
  BannerSection: typeof BannerSection;
};

const FeatureDiscovery: FeatureDiscovery = FeatureDiscoveryComponent as any;

FeatureDiscovery.Section = Section;
FeatureDiscovery.BannerSection = BannerSection;

export { FeatureDiscovery };
